import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

declare const __APP_BUILD_INFO__: {
  commit: string;
  branch: string;
  builtAt: string;
  environment: string;
};

declare global {
  interface Window {
    __APP_BUILD_INFO__?: {
      commit: string;
      branch?: string;
      builtAt: string;
      environment: string;
    };
  }
}

if (typeof window !== 'undefined') {
  window.__APP_BUILD_INFO__ = typeof __APP_BUILD_INFO__ !== 'undefined'
    ? __APP_BUILD_INFO__
    : {
        commit: 'prod-head',
        branch: 'main',
        builtAt: new Date().toISOString(),
        environment: 'production',
      };
}

import { HelmetProvider } from 'react-helmet-async';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
);
